<template>
  <table class="uk-table uk-table-hover uk-table-divider">
    <thead>
      <tr>
        <th class="uk-table-shrink">#</th>
        <th class="uk-table-expand">Fahrzeug</th>
        <th class="uk-table-shrink uk-text-center">Angebote</th>
        <th class="uk-width-small uk-text-right">UPE Preis</th>
        <th class="uk-width-small"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="vehicle in vehicles" :key="vehicle.id">
        <td>
          <router-link :to="{ name: 'admin.exchange.vehicle.edit', params: { id: vehicle.id } }">
            {{ vehicle.number }}
          </router-link>
        </td>
        <td>
          {{ vehicle.name }}
        </td>
        <td class="uk-text-center">{{ vehicle.offers.length }}</td>
        <td class="uk-text-right">
          {{ vehicle.priceFormatted }}
        </td>
        <td class="uk-text-nowrap">
          <div class="uk-align-right uk-margin-right">
            <a href="#" class="uk-icon-link" uk-icon="more"></a>
            <div data-uk-dropdown="mode: click;animation: uk-animation-slide-top-small;">
              <ul class="uk-nav uk-dropdown-nav uk-text-left">
                <li>
                  <router-link :to="{ name: 'admin.exchange.vehicle.edit', params: { id: vehicle.id } }">
                    Details
                  </router-link>
                </li>
                <li class="uk-nav-divider uk-margin-remove"></li>
                <li>
                  <a class="uk-text-danger uk-dropdown-close" href="#" @click.prevent="remove(vehicle.id)">
                    <span class="uk-icon" data-uk-icon="icon: trash"></span>&nbsp;
                    Löschen
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import ExchangeService from '@/services/exchange.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
export default {
  props: {
    vehicles: {
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    remove(id) {
      const $this = this
      this.$uikit.modal
        .confirm('Fahrzeug wirklich löschen? <br><span class="uk-text-danger">Es werden außerdem alle abgegebenen Angebote gelöscht!</span>', {
          labels: {
            cancel: 'Abbrechen',
            ok: 'Löschen'
          }
        })
        .then(
          function () {
            ExchangeService.deleteVehicle(id).then(() => {
              iziToast.success({
                position: 'topCenter',
                title: 'OK',
                message: 'Fahrzeug gelöscht!'
              })
              $this.$emit('removed')
            })
          },
          function () {
            //
          }
        )
    },
  }
}
</script>
  